import { TicketsPage } from "../../../../pages/tickets/tickets/TicketsPage";
import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

const TicketsEntryPage = ({ space, scope }: Props) => {
  return <TicketsPage space={space} scope={scope} />;
};

export default TicketsEntryPage;
